import {
    ApiOrderStatus,
    ApiOrderType,
    ApiPaymentStatus,
    ApiRocketTaskStatus,
    type OrderResponse,
    type OrderTaskResponse,
} from '@/core/generated/api';

/** Определяет доступность действий заказа */
export const getOrderActionState = (order: OrderResponse, task?: OrderTaskResponse | null) => {
    const isExecutorApproved = order.status?.id === ApiOrderStatus.ExecutorApproved;
    const isInProgress = order.status?.id === ApiOrderStatus.InProgress;
    const isExecutorAssigned = order.status?.id === ApiOrderStatus.Assigned;
    const isDraft = order.status?.id === ApiOrderStatus.Draft;
    const isCompleted = order.status?.id === ApiOrderStatus.Completed;
    const isCancelled = order.status?.id === ApiOrderStatus.Cancelled;
    const isDogWalking = order.orderType?.id === ApiOrderType.DogWalking;
    const isSearchable = order.status?.id === ApiOrderStatus.Searchable;
    const isRequestPending = order.status?.id === ApiOrderStatus.RequestPending;
    const isSentToSignDocuments = order.status?.id === ApiOrderStatus.SentToSignDocuments;

    const shouldShowCancelButton = isExecutorApproved || isExecutorAssigned || isSearchable
        || isSentToSignDocuments || isRequestPending;

    const shouldShowCreatePaymentButton = (isDraft && isDogWalking) || isExecutorApproved;
    const shouldShowStartExecutorSearchButton = isDraft && !isDogWalking;

    const canRemoveExecutor = Boolean(order.executorId) && (isRequestPending || isSentToSignDocuments
        || isExecutorApproved || isExecutorAssigned);

    const shouldShowPayForTaskButton = task?.status?.id === ApiRocketTaskStatus.Accepting
        || task?.status?.id === ApiRocketTaskStatus.Error;

    const shouldShowManualPaymentConfirmButton = order.payment?.status?.id === ApiPaymentStatus.New
        && ((isDraft && isDogWalking) || (isExecutorApproved && !isDogWalking));

    return {
        isExecutorApproved,
        isInProgress,
        isExecutorAssigned,
        isDraft,
        isCompleted,
        isCancelled,
        isDogWalking,
        isSearchable,
        isRequestPending,
        isSentToSignDocuments,
        shouldShowCancelButton,
        shouldShowCreatePaymentButton,
        shouldShowStartExecutorSearchButton,
        canRemoveExecutor,
        shouldShowPayForTaskButton,
        shouldShowManualPaymentConfirmButton,
    };
};
